import { useState } from 'react';
import { logger } from '../../common/logger';

type SetState<T> = (value: T | ((prevState: T) => T)) => void;

export const useSessionStorage = <T>(
  key: string,
  initialValue: T
): [T, SetState<T>] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.sessionStorage.getItem(key);
      if (item) {
        return JSON.parse(item) as T;
      }
    } catch (error) {
      logger.error({ error }, 'Error getting session storage value.');
    }
    return initialValue;
  });

  const setValue: SetState<T> = value => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;

      setStoredValue(valueToStore);

      window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      logger.error({ error }, 'Error setting session storage value.');
    }
  };

  return [storedValue, setValue];
};
